module.exports = __webpack_public_path__ + "img/knowledge.e1e0521f.png";